<template>
  <u-divider orientation="vertical" class="h-6" :ui="{border: {base: 'dark:border-charcoal'}}" />
</template>
